import React from 'react'
import styled from 'styled-components'
import { Modal, ModalProps } from 'vvs-uikit'
import { useKeyPressEvent } from 'react-use'
import BoostFarmQAContent from './BoostFarmQAContent'
import BoostFarmQAHeader from './BoostFarmQAHeader'

const StyledModal = styled(Modal)<ModalProps>`
  border: none;
`

interface BoostFarmQAModalProps {
  onDismiss?: () => void
}

const BoostFarmQAModal: React.FC<BoostFarmQAModalProps> = ({ onDismiss }) => {
  useKeyPressEvent('Escape', () => {
    onDismiss()
  })
  return (
    <StyledModal title="" bodyPadding="0" onDismiss={onDismiss} hideCloseButton hideHeader>
      <BoostFarmQAHeader onCloseBtnClick={onDismiss} hideBackPrevButton />
      <BoostFarmQAContent onDismiss={onDismiss} />
    </StyledModal>
  )
}

export default BoostFarmQAModal
